import { Box, Stack, Typography } from "@mui/material";
import React from "react";

import type { AnswerUpdate, Answers, InputProps, QuestionType } from "./answers";
import type { Question } from "./contents";
import { QUESTION_INPUTS } from "./questionTypes";

type Props = {
    questions: Question[];
    answers: Answers;
    onChange: (id: string, answer: AnswerUpdate) => void;
};

export const FieldRequestsSection: React.FC<Props> = ({ questions, answers, onChange }) => (
    <Stack sx={{ px: { xs: 2, sm: 3 }, "& > * + *": { borderTop: "1px solid", borderColor: "divider" } }}>
        {questions.map((question) => {
            const Input = QUESTION_INPUTS[question.type] as React.FC<InputProps<QuestionType>>;
            return (
                <Stack
                    key={question.id}
                    id={`question-${question.id}`}
                    direction={{ xs: "column", sm: "row" }}
                    spacing={{ xs: 1, sm: 2 }}
                    alignItems={{ sm: "center" }}
                    sx={{ py: 2, scrollMarginTop: 96 }}
                >
                    <Typography variant="textSm" fontWeight={500} sx={{ width: { sm: 220 }, flexShrink: 0 }}>
                        {question.title}
                    </Typography>
                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            maxWidth: 480,
                            "& .MuiTextField-root, & .MuiAutocomplete-root": { width: 1, maxWidth: "none" },
                        }}
                    >
                        <Input
                            question={question}
                            answer={answers[question.id]}
                            onChange={(update) => onChange(question.id, update)}
                            error={false}
                            compact
                        />
                    </Box>
                </Stack>
            );
        })}
    </Stack>
);
